import request from '@/utils/request'

export function smsList(data) {
    return request({
        url: '/backend/sms/list',
        method: 'post',
        data: data
    })
}

export function typeInfo(data) {
    return request({
        url: '/backend/activity/camp/typeInfo',
        method: 'post',
        data: data
    })
}

export function getSmsTempList(data) {
    return request({
        url: '/backend/sms/getSmsTempList',
        method: 'post',
        data: data
    })
}
export function createTemplate(data) {
    return request({
        url: '/backend/sms/createTemplate',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/sms/updateStatus',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/sms/delete',
        method: 'post',
        data: data
    })
}
export function sendSms(data) {
    return request({
        url: '/backend/sms/sendSms',
        method: 'post',
        data: data
    })
}